import CustomCardHeader from "../../components/card/CustomCardHeader";
import {SemiTransparentButton} from "../../components/CustomButton";
import CardBody from "../../components/card/CardBody";
import CustomTable from "../../components/table/CustomTable";
import CustomCard from "../../components/card/CustomCard";
import ManageUserTable from "./components/ManageUserTable";
import ManageUserFormModal from "./components/ManageUserFormModal";
import {
  resetManageUsers,
  setAdminsTableMode,
  setManageUserModals,
  setSelectedTab
} from "../../redux/slices/manageUserSlice";
import {useDispatch, useSelector} from "react-redux";
import UsersPaginator from "./components/UsersPaginator";
import {ADMIN_USERS, NORMAL_USERS, TABLE_DISPLAY_MODE_FEATURES} from "./constants";
import ManageUserTableHeader from "./components/ManageUserTableHeader";
import ManageUserConfirmModal from "./components/ManageUserConfirmModal";
import AddFeaturesModal from "./components/AddFeaturesModal";
import {useEffect} from "react";
import {TabCardHeader} from "components/tab/CustomTab";
import {CommonTabGroup} from "components/tab/TabGroup";
import {CommonTab} from "components/tab/CustomTab";

export default function ManageUser() {

  const dispatch = useDispatch();


  useEffect(() => {

    return () => {
      dispatch(resetManageUsers());
    };
  }, []);

  const userListTab = useSelector((state) => state.manageUser.displayMode) === TABLE_DISPLAY_MODE_FEATURES;
  const adminListTab = useSelector((state) => state.manageUser.selectedTab) !== ADMIN_USERS;

  return (
    <>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <CustomCard>
              <CustomCardHeader color="blue" contentPosition="none" className="pd-y-0">
                <div className="flex items-center justify-between w-full h-full">
                  <div className="inline-flex overflow-hidden h-full">
                    <UsersAdminsTab/>
                  </div>
                  <div className="flex space-x-2">
                    <CreateUsersButton/>
                  </div>

                </div>
              </CustomCardHeader>
              <CardBody>
                <PermissionToggleTab/>
                <div
                  className={(userListTab && adminListTab) ? "overflow-x-auto border rounded-lg pb-4 mt-8" : "overflow-x-auto"}>
                  {(userListTab && adminListTab) &&
                    <div className="flex text-center border-b divide-x text-sm font-medium">
                      <div className="w-44 shrink-0 py-3">Features</div>
                      <div className="w-full py-3">Users</div>
                    </div>}
                  <CustomTable className={`${(userListTab && adminListTab) ? "px-4 " : ""}table-fixed`}>
                    <ManageUserTableHeader/>
                    <ManageUserTable/>
                  </CustomTable>
                  <UsersPaginator/>
                </div>

              </CardBody>
            </CustomCard>
            <ManageUserFormModal fromList={true}/>
            <ManageUserConfirmModal/>
            <AddFeaturesModal/>
          </div>
        </div>
      </div>
    </>
  );
}

const PermissionToggleTab = () => {
  const displayMode = useSelector((state) => state.manageUser.displayMode);
  const selectedTab = useSelector((state) => state.manageUser.selectedTab);
  const dispatch = useDispatch();

  const isFeaturesTabSelected = displayMode === TABLE_DISPLAY_MODE_FEATURES;

  return (
    <>
      {selectedTab === NORMAL_USERS && <CommonTabGroup>
        <CommonTab active={isFeaturesTabSelected}
                   onClick={() => !isFeaturesTabSelected && dispatch(setAdminsTableMode())}>Permissions</CommonTab>
        <CommonTab active={!isFeaturesTabSelected}
                   onClick={() => isFeaturesTabSelected && dispatch(setAdminsTableMode())}>All Users</CommonTab>
      </CommonTabGroup>}
    </>
  );
};

const UsersAdminsTab = () => {
  const selectedTab = useSelector((state) => state.manageUser.selectedTab);
  const _user = useSelector((state) => state.authToken.user);
  const dispatch = useDispatch();

  const isAdminTabSelected = selectedTab === ADMIN_USERS;

  return (
    <>
      {
        !!_user?.super_admin &&

        <>
          <TabCardHeader label="Users" active={!isAdminTabSelected} onClick={() => isAdminTabSelected && dispatch(setSelectedTab())}/>
          <TabCardHeader label="Admins" active={isAdminTabSelected} onClick={() => !isAdminTabSelected && dispatch(setSelectedTab())}/>
        </>
      }

    </>
  );
};

const ToggleAdminButton = () => {
  const selectedTab = useSelector((state) => state.manageUser.selectedTab);
  const _user = useSelector((state) => state.authToken.user);
  const dispatch = useDispatch();

  return (
    <>
      {
        !!_user?.super_admin &&

        <SemiTransparentButton onClick={() => dispatch(setSelectedTab())}>
          {selectedTab === ADMIN_USERS ? 'Users' : 'Admins'}
        </SemiTransparentButton>
      }

    </>
  );
};

const ToggleDisplayModeButton = () => {
  const displayMode = useSelector((state) => state.manageUser.displayMode);
  const selectedTab = useSelector((state) => state.manageUser.selectedTab);
  const dispatch = useDispatch();

  return (
    <>
      {selectedTab === NORMAL_USERS && <SemiTransparentButton onClick={() => dispatch(setAdminsTableMode())}>
        {displayMode === TABLE_DISPLAY_MODE_FEATURES ? 'Actions' : 'Features'}
      </SemiTransparentButton>}
    </>
  );
};

const CreateUsersButton = () => {
  const selectedTab = useSelector((state) => state.manageUser.selectedTab);
  const dispatch = useDispatch();

  return (
    <>
      {selectedTab === NORMAL_USERS &&
        <SemiTransparentButton onClick={() => dispatch(setManageUserModals({modal: true}))}>
          + Create
        </SemiTransparentButton>
      }
    </>
  );
};